import { Button, Card, CardContent, Input, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import PerfectScrollbar from 'react-perfect-scrollbar';
import api from '../../../services/api';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import PageviewOutlinedIcon from '@material-ui/icons/PageviewOutlined';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal/DeleteConfirmationModal';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class ContaCorrenteList extends Component {
    state = {
        contascorrentes: [],
        searchFilter: {
            nomeClienteConta: '',
            situacaoInativoFilter: ANAO,
        },
    };

    estilo = {
        marginLeft: 30,
        marginTop: 30,
        marginRight: 30,
        container: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
        addButton: {
            height: '42px',
            display: 'flex',
            alignItems: 'center',
            float: 'right', // alinhamento a direita
            marginTop: 3,
            marginRight: 3
        },
        redText: {
            color: 'red',
        },
    };

    constructor(props) {
        super(props);
    }

    /* carregamento inicial */
    async componentDidMount() {
        this.loadContasCorrentes();
    }

    /* Carrega Contas Correntes */
    loadContasCorrentes = async () => {
        const { searchFilter } = this.state;
        let params = '';

        /* consulta pelo cliente da conta corrente */
        if (!(searchFilter.nomeClienteConta === '')) {
            params += '?tbconta.clienteconta=_like_' + searchFilter.nomeClienteConta
        }

        /* filtra situação da conta corrente */
        switch (searchFilter.situacaoInativoFilter) {
            case ASIM:
                if (params) {
                    params += '&tbconta.inativo=' + ASIM
                }
                else
                    params += '?tbconta.inativo=' + ASIM;
                break;
            case ANAO:
                if (params) {
                    params += '&tbconta.inativo=' + ANAO
                }
                else
                    params += '?tbconta.inativo=' + ANAO;
                break;
            default:
                break;
        }

        const response = await api.get('/financas/conta' + params);
        this.setState({ contascorrentes: response.data });
    }

    /* Escolha de uma conta para exclusão */
    handleSelectItem = (id) => {
        this.setState({ selectedId: id });
    };

    /* deleta conta corrente */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/financas/conta/${id}`);
            // Verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadContasCorrentes();
            }
        } catch (error) {
            this.handleClose();
            this.handleOpenAlert(error.response.data.error);
            console.log(error);
            console.log(error.message);
        }
    };

    /* abre janela confirmação para exclusão */
    handleOpen = (cdconta) => {
        this.setState({ open: true });
        this.handleSelectItem(cdconta);
    };

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* fecha janela de confirmação exclusão */
    handleClose = () => {
        this.setState({ open: false });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    }

    /* Pesquisar filtros na tela */
    OnChangeSearch = (event) => {
        const { searchFilter } = this.state;
        let { name, value } = event.target;
        value = value.toUpperCase()
        searchFilter[name] = value;
        this.setState({ searchFilter: searchFilter });
        if (name === 'situacaoInativoFilter') {
            this.loadContasCorrentes();
        }
    };

    /* Limpa Filtros na tela */
    LimpaFiltros = () => {
        let { searchFilter } = this.state;
        searchFilter.nomeClienteConta = '';
        searchFilter.situacaoInativoFilter = 'N';
        this.setState({ searchFilter: searchFilter });
    }

    render() {
        const { contascorrentes } = this.state;
        const { searchFilter } = this.state;
        return (
            <div style={this.estilo}>
                <Button
                    component={Link}
                    to="/financas/contascorrentes/novo"
                    variant="contained"
                    color="primary"
                    style={this.estilo.addButton}
                >
                    Novo
                </Button>

                <Paper hover>
                    <Input
                        autoFocus
                        id="nomeClienteConta"
                        name="nomeClienteConta"
                        onBlur={this.onInputBlur}
                        onChange={this.OnChangeSearch}
                        placeholder="Nome cliente a pesquisar"
                        style={{ marginBottom: 10, width: 300, marginLeft: 10, marginTop: 10 }}
                        value={searchFilter.nomeClienteConta}
                    />

                    <Select
                        id="situacaoInativoFilter"
                        name="situacaoInativoFilter"
                        style={{ marginLeft: 20 }}
                        value={searchFilter.situacaoInativoFilter || ''}
                        onChange={this.OnChangeSearch}
                    >
                        <MenuItem value={ANAO}>Ativos</MenuItem>
                        <MenuItem value={ASIM}>Inativos</MenuItem>
                        <MenuItem value={'T'}>Todos</MenuItem>
                    </Select>

                    <Button
                        color="primary"
                        id="pesquisar"
                        onClick={() => this.loadContasCorrentes()}
                    >
                        <SearchIcon />
                    </Button>

                    <Button
                        color="primary"
                        onClick={() => this.LimpaFiltros()}
                    >
                        <ClearAllIcon />
                    </Button>
                </Paper>

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Código</TableCell>
                                            <TableCell>Nº Conta</TableCell>
                                            <TableCell>Cliente Conta</TableCell>
                                            <TableCell>Agência</TableCell>
                                            <TableCell>Banco</TableCell>
                                            <TableCell>Ações</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {contascorrentes.slice(0, 100).map(contacorrente => (
                                            <TableRow
                                                hover
                                                key={contacorrente.cdconta}
                                            >
                                                <TableCell style={(contacorrente.inativo === ASIM) ? this.estilo.redText : {}}>{contacorrente.cdconta}</TableCell>

                                                <TableCell style={(contacorrente.inativo === ASIM) ? this.estilo.redText : {}} >{contacorrente.nroconta}</TableCell>

                                                <TableCell style={(contacorrente.inativo === ASIM) ? this.estilo.redText : {}} >{contacorrente.clienteconta}</TableCell>

                                                <TableCell style={(contacorrente.inativo === ASIM) ? this.estilo.redText : {}} >{contacorrente.agenconta}</TableCell>

                                                <TableCell style={(contacorrente.inativo === ASIM) ? this.estilo.redText : {}} >{contacorrente.descbanco}</TableCell>

                                                <TableCell>
                                                    <Link to={`/financas/contascorrentes/${contacorrente.cdconta}`}>
                                                        <EditOutlinedIcon style={{ cursor: 'pointer', marginRight: '10px' }} />
                                                    </Link>
                                                    <Link to={`/financas/contascorrentes/${contacorrente.cdconta}/view`}>
                                                        <PageviewOutlinedIcon style={{ cursor: 'pointer', marginRight: '10px' }} />
                                                    </Link>
                                                    <DeleteForeverOutlinedIcon
                                                        onClick={() => this.handleOpen(contacorrente.cdconta)}
                                                        style={{ cursor: 'pointer', marginRight: '10px' }} />
                                                </TableCell>

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>
                    </CardContent>
                </Card>
                <DeleteConfirmationModal
                    open={this.state.open}
                    handleClose={() => this.handleClose()}
                    itemId={this.state.selectedId}
                    message={"Confirma exclusão da conta corrente " + this.state.selectedId + '?'}
                    handleDelete={() => this.handleDelete(this.state.selectedId)}
                />

                <AlertInformation
                    open={this.state.openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={this.state.messageAlert}
                />
            </div>
        );
    }
}

export default ContaCorrenteList;